import { escapeCell } from '../TagBlockersDialog';

export interface IInaccessibleSource {
  modelName: string;
  modelInstanceName: string;
}

// CLD-2910: names come from the API, so cells go through the formula-safe escapeCell.
export const downloadInaccessibleSourcesCsv = (
  sources: IInaccessibleSource[]
): void => {
  const rows = [
    ['Model', 'Model Instance'],
    ...sources.map((s) => [s.modelName, s.modelInstanceName]),
  ].map((row) => row.map(escapeCell).join(','));

  const blob = new Blob([rows.join('\r\n')], {
    type: 'text/csv;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'inaccessible-sources.csv';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
